import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CommonModule} from '@angular/common';
import {HttpService} from "../service/http.service";
import {GalleryComponent, GalleryItem, GalleryItemEvent} from "@daelmaak/ngx-gallery";
import {MatDialog} from "@angular/material/dialog";
import {DialogImagePopupComponent} from "./modal/dialog-image-popup/dialog-image-popup.component";
import {BehaviorSubject} from "rxjs";
import {MatButton} from "@angular/material/button";


@Component({
  selector: 'app-card-details',
  templateUrl: './card-details.component.html',
  styleUrls: ['./card-details.component.css'],
  standalone: true,
  imports: [CommonModule, GalleryComponent, MatButton]
})
export class CardDetailsComponent implements OnInit {

  constructor(public httpService: HttpService,
              private dialog: MatDialog,
              private route: ActivatedRoute) {
  }

  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  ddptInfo: any
  ddpkId: any
  companyOid: any

  base64String = 'data:image/jpeg;base64,';
  images: GalleryItem[] = []

  ngOnInit(): void {
    this.isLoading.next(true);
    this.route.paramMap.subscribe(params => {
      const ddpkId = params.get('id');
      console.log('ddpkId:', ddpkId);
      this.ddpkId = ddpkId;

      this.route.queryParams.subscribe(params => {
        const urlHost = window.location.hostname; // dohvaća npr. "zagrebparking.dpk.hr" ili "dpk.rao.hr"
        console.log('Hostname:', urlHost);

        // default companyOid iz query param (ako postoji)
        let paramOid = params['company-oid'] || '';

        if (urlHost.includes('zagrebparking.dpk.hr')) {
          this.companyOid = '402880a825447882012544788b750002'

          console.log('CompanyId (Zagreb parking): ', this.companyOid);

        } else if (urlHost.includes('rao.hr')) {
          // Za rao.hr koristimo query param ili default
          this.companyOid = paramOid

        } else {
          console.error('Nepodržana domena:', urlHost);
        }

        console.log('companyOid:', this.companyOid);

        this.getGGPTInfo()
        this.getImages()

      });
    });
  }

  getGGPTInfo() {
    this.httpService.getDDPTInfo(this.ddpkId, this.companyOid)
      .subscribe({
        next: (res) => {
          if (res) this.ddptInfo = res
        }, error: (err) => {
          console.error('getDDPTInfoError: ', err);
        }, complete: () => {
        }
      })
  }

  openInstantPay() {
    const url = 'https://app.bmove.com/purchase/payment-order/81NAPLATA_DPK1DNEVNA/'
      + this.ddptInfo.ddptNumber;

    window.open(url, '_blank');
  }


  getImages() {
    this.httpService.getImages(this.ddpkId, this.companyOid)
      .subscribe({
        next: (res) => {
          console.log('images: ', res)
          if (res.length) {
            this.images = [];
            res.map((img: any) => {
              this.images.push({src: this.base64String + img})
            });
          }
        }, error: (err) => {
          this.isLoading.next(false);
          this.images = []
          console.error('getImagesError: ', err.statusText);
        }, complete: () => {
          this.isLoading.next(false);
        }
      })
  }

  onImageClick(item: GalleryItemEvent) {
    const isMobile = window.innerWidth <= 768;

    this.dialog.open(DialogImagePopupComponent, {
      width: isMobile ? '95vw' : '90vw',
      maxWidth: isMobile ? '100vw' : '1400px',
      height: 'auto',
      maxHeight: isMobile ? '95vh' : '90vh',
      closeOnNavigation: true,
      hasBackdrop: true,
      panelClass: 'responsive-dialog',
      data: {images: this.images, selectedIndex: item.index},
    });
  }

}
